module.exports = __webpack_public_path__ + "static/img/qd_type0.a26696a.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/qd_type0.png
// module id = aRTJ
// module chunks = 167